import React, {Component} from "react";
import {injectIntl} from "react-intl";

class PasswordStrengthComponent extends Component {

  static calculateColor(score) {
    switch (score) {
      case 0:
      case 1:
        return "#f5222d";
      case 2:
        return "#faad14";
      case 3:
      case 4:
        return "#52c41a";
    }
  }

  static calculateWidth(score) {
    switch (score) {
      case 0:
        return "20%";
      case 1:
        return "40%";
      case 2:
        return "60%";
      case 3:
        return "90%";
      case 4:
        return "100%";
    }
  }

  static calculateStength(score, language) {
    switch (score) {
      case 0:
        return language("user_service_password_strength_weakest_txt");
      case 1:
        return language("user_service_password_strength_weaker_txt");
      case 2:
        return language("user_service_password_strength_normal_txt");
      case 3:
        return language("user_service_password_strength_stronger_txt");
      case 4:
        return language("user_service_password_strength_strongest_txt");
    }
  }

  render() {
    const zxcvbn = require('zxcvbn');
    let score = zxcvbn(this.props.password).score;
    console.debug("PasswordStrengthComponent: calculate score ", score);

    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        width: "100%",
        margin: "0 auto",
        padding: "1em",
        borderRadius: "4px",
        background: "white"
      }}>
        <div style={{
          color: PasswordStrengthComponent.calculateColor(score),
          marginBottom: "8px"
        }}>{this.language("user_service_password_strength_indicator_txt")}: {PasswordStrengthComponent.calculateStength(score, this.language.bind(this))}</div>
        <div style={{
          background: "rgba(0,0,0,.1)",
          width: "100%",
          height: "6px",
          borderRadius: "2px",
          marginBottom: "16px"
        }}>
          <div style={{
            background: PasswordStrengthComponent.calculateColor(score),
            width: PasswordStrengthComponent.calculateWidth(score),
            height: "6px",
            borderRadius: "2px"
          }}>
          </div>
        </div>
        <div>
          <ul style={{paddingLeft: "1em"}}>
            <li>{this.language("user_service_password_strength_requirement_one")}</li>
            <li>{this.language("user_service_password_strength_requirement_two")}</li>
            <li>{this.language("user_service_password_strength_requirement_three")}</li>
            <li>{this.language("user_service_password_strength_requirement_four")}</li>
          </ul>
        </div>
      </div>
    )
  }

  language(value) {
    return this.props.intl.formatMessage({id: value});
  }
}

export default injectIntl(PasswordStrengthComponent);
